module.exports = "/images/meet-the-smartys.png?37632876bbcc06d7bb29304b5190ddb4";